import { useMemo } from "react";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, PointElement, Tooltip, Legend, Title } from 'chart.js';
import { Bar } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, PointElement, Tooltip, Legend, Title);

const COLORS = ['#FFD700', '#1E90FF', '#FF6347', '#8A2BE2', '#32CD32', '#FF4500', '#00CED1'];

const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: { display: true, position: 'top' as const },
        title: { display: true, text: 'Total Revenue by Sport' },
    },
    scales: {
        x: { title: { display: true, text: 'Sport (Box Type)' } },
        y: { title: { display: true, text: 'Total Revenue' }, beginAtZero: true },
    },
};

const MultiBarChart = ({ bookings }: { bookings: any[] }) => {
    const chartData = useMemo(() => {
        const revenueByBoxType: Record<string, number> = {};

        bookings.forEach((booking: any) => {
            const boxType = booking.box_type;
            booking.slots.forEach((slot: { price: any }) => {
                revenueByBoxType[boxType] = (revenueByBoxType[boxType] || 0) + parseFloat(slot.price);
            });
        });

        const labels = Object.keys(revenueByBoxType);
        return {
            labels,
            datasets: [{
                label: 'Total Revenue by Sport',
                data: Object.values(revenueByBoxType),
                backgroundColor: labels.map((_, i) => COLORS[i % COLORS.length]),
                borderColor: labels.map((_, i) => COLORS[i % COLORS.length]),
                borderWidth: 1,
            }],
        };
    }, [bookings]);

    return (
        <div className="w-full rounded-xl border bg-card p-3 lg:p-4">
            <p className="text-base lg:text-lg font-semibold">Revenue By Sport</p>
            <div className="mt-3 h-72 lg:h-80">
                <Bar data={chartData} options={options} />
            </div>
        </div>
    );
};

export default MultiBarChart;
